module.exports = "/v8.41.0/b1a3087/bundles/opensearch.xml";